import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this._openHandlers = new Map();

		this.events = {
			click: {
				close: "close",
			},
		};
	}

	init() {
		this.id = this.el.getAttribute("data-module-modal");

		document.querySelectorAll("[data-modal-open='" + this.id + "']").forEach((element) => {
			var _openHandler = (event) => {
				event.preventDefault();
				this.open();
			};
			this._openHandlers.set(element, _openHandler);
			element.addEventListener("click", _openHandler);
		});

		this._keydownHandler = this.keydown.bind(this);
		document.addEventListener("keydown", this._keydownHandler);

		this._closeHandler = this.close.bind(this);
		document.addEventListener("overlay:click", this._closeHandler);
	}

	open() {
		this.el.classList.add("is-active");
		this.call("open", { aboveHeader: false }, "overlay");
		window.lenis.stop();
	}

	keydown(event) {
		if (event.keyCode == 27) {
			this.close();
		}
	}

	close() {
		this.el.classList.remove("is-active");
		this.call("close", {}, "overlay");
		window.lenis.start();
	}

	destroy() {
		this._openHandlers.forEach((handler, element) => {
			element.removeEventListener("click", handler);
		});
		this._openHandlers.clear();
		document.removeEventListener("keydown", this._keydownHandler);
		document.removeEventListener("overlay:click", this._closeHandler);
	}
}
